import type { AttendancePlayer } from '../types'

// Names of the other players sharing this player's jersey number. Compares the
// string form because the API returns player_number as a number or a string.
export const getJerseyConflictNames = (
  player: AttendancePlayer,
  allPlayers: AttendancePlayer[]
): string[] => {
  if (player.player_number == null || player.player_number === '') {
    return []
  }
  const number = String(player.player_number)
  return allPlayers
    .filter((p) => p.id !== player.id && String(p.player_number) === number)
    .map((p) => [p.name_first, p.name_last].filter(Boolean).join(' ').trim())
    .filter(Boolean)
}
